import { render, staticRenderFns } from "./StuffList.vue?vue&type=template&id=07d80597&scoped=true"
import script from "./StuffList.vue?vue&type=script&lang=js"
export * from "./StuffList.vue?vue&type=script&lang=js"
import style0 from "./StuffList.vue?vue&type=style&index=0&id=07d80597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d80597",
  null
  
)

export default component.exports